module.exports = "/remote-dist/63582965ad91ee7b1adee0ad458e0702.png";